import { useQuery } from "@tanstack/react-query";
import ReactSelect from "react-select";
import { getCountries } from "../../queries/auth";
import { useState } from "react";

export interface CountryData {
  id: number;
  name: string;
  dial_code: string;
  flag: string;
  default: boolean;
  active: boolean;
  code: string;
  dial_max_length: number;
  dial_min_length: number;
}

interface PhoneNumberProps {
  returnValues: (dialCode: string, mobile: string) => void;
}

export default function PhoneNumber({ returnValues }: PhoneNumberProps) {
  const [dialCode, setDialCode] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  function handleChange() {
    returnValues(dialCode, mobile);
  }
  // fetch countries
  const { data } = useQuery({ queryKey: ["countries"], queryFn: getCountries });
  return (
    <div>
      <label htmlFor="mobile" className="secondary-text">
        Phone Number
      </label>
      <div className="py-3 rounded-lg border border-border flex items-center px-3 mt-1 space-x-3">
        <ReactSelect
          className=""
          options={data}
          onChange={(val) => setDialCode(val!.dial_code)}
          formatOptionLabel={(country: CountryData) => (
            <div className="w-fit">
              <img src={country.flag} alt="" />
            </div>
          )}
        />
        <input
          onKeyUp={() => handleChange()}
          onChange={(e) => setMobile(e.target.value)}
          type="text"
          name="mobile"
          required
          placeholder="80123"
          className="font-medium"
        />
      </div>
    </div>
  );
}
